/* Block - Cards.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "./block-cards.scss";
import rsCardLink from '../../js/component/_card';

rsCardLink.init('.rs-card-container');
